"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _request = require("../../common/request");

var _request2 = _interopRequireDefault(_request);

var _constants = require("../../utils/constants");

var CONSTANTS = _interopRequireWildcard(_constants);

var _Llistat = require("./Llistat.css");

var _Llistat2 = _interopRequireDefault(_Llistat);

var _FixedMenuLayout = require("../../layouts/FixedMenuLayout");

var _FixedMenuLayout2 = _interopRequireDefault(_FixedMenuLayout);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //      

var Llistat = function (_React$Component) {
	_inherits(Llistat, _React$Component);

	function Llistat(props) {
		_classCallCheck(this, Llistat);

		var _this = _possibleConstructorReturn(this, (Llistat.__proto__ || Object.getPrototypeOf(Llistat)).call(this, props));

		_this.checkDinamic = function (tipus, dynamic) {
			return tipus === "latest" || dynamic ? tipus + " / din\xE0mic" : tipus + " / no din\xE0mic";
		};

		_this.isPublicat = function (title) {
			return title !== CONSTANTS.DEFAULT_TITOL_GENERIC;
		};

		_this.state = {
			loadedData: null,
			loading: true,
			showError: false,
			errorMsg: "",
			currentAction: null,
			titleMsg: "",
			filtreCerca: "",
			bodyMsg: "",
			open: false,
			timestampEstacions: "Carregant info...",
			timestampIndexos: "Carregant info..."
		};
		return _this;
	}

	_createClass(Llistat, [{
		key: "componentDidMount",
		value: function componentDidMount() {

			this.loadApplications();
			//this.loadTimestamps();
		}
	}, {
		key: "loadTimestamps",
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
				var timestampsEstacions, timestampIndexos;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return this.getLastUpdateTimestamp("estacions");

							case 2:
								timestampsEstacions = _context.sent;
								_context.next = 5;
								return this.getLastUpdateTimestamp("indexos");

							case 5:
								timestampIndexos = _context.sent;


								this.setState({
									open: false,
									currentAction: null,
									timestampEstacions: timestampsEstacions,
									timestampIndexos: timestampIndexos
								});

							case 7:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function loadTimestamps() {
				return _ref.apply(this, arguments);
			}

			return loadTimestamps;
		}()
	}, {
		key: "loadApplications",
		value: function loadApplications() {
			var _this2 = this;

			_request2.default.get(CONSTANTS.URL_GET_CONFIG).then(function (data) {

				_this2.setState({
					loading: false,
					loadedData: data, //.filter(visor => this.isPublicat(visor.title)),
					deleteindex: -1,
					open: false
				});
			}).catch(function (err) {

				_this2.setState({ loading: false, showError: true, errorMsg: err });
			});
		}
	}, {
		key: "getLastUpdateTimestamp",
		value: function getLastUpdateTimestamp(tipusFile) {

			return new Promise(function (resolve) {

				_request2.default.get(CONSTANTS.URL_SERVER + "/timestamp." + tipusFile + ".txt").then(function (timestamp) {
					return resolve(timestamp);
				}).catch(function () {
					return resolve("");
				});
			});
		}
	}, {
		key: "onSelectVisors",
		value: function onSelectVisors(valor) {

			this.setState({ filtreCerca: valor });
		}
	}, {
		key: "renderIsNoPublicat",
		value: function renderIsNoPublicat() {

			return _react2.default.createElement(
				_semanticUiReact.Message,
				{ size: "small", compact: true, warning: true },
				_react2.default.createElement(_semanticUiReact.Icon, { name: "warning" }),
				"Visor no publicat"
			);
		}
	}, {
		key: "renderLListatApps",
		value: function renderLListatApps(station, i) {

			if (this.isPublicat(station.title)) {

				return _react2.default.createElement(
					_semanticUiReact.Table.Row,
					{ key: i },
					_react2.default.createElement(
						_semanticUiReact.Table.Cell,
						null,
						_react2.default.createElement(
							"a",
							{ title: "Visor", target: "_blank", rel: "noopener noreferrer", href: CONSTANTS.URL_APP + "/visor/" + station.organization + "/" + station.apps.visor },
							_react2.default.createElement(
								"span",
								{ className: this.isPublicat(station.title) ? _Llistat2.default.titlePublicat : _Llistat2.default.titleNoPublicat },
								station.title + " - " + station.organization
							)
						)
					)
				);
			} else {

				return " ";
			}
		}
	}, {
		key: "renderApplications",
		value: function renderApplications() {
			var _this3 = this;

			var _state = this.state,
			    loadedData = _state.loadedData,
			    filtreCerca = _state.filtreCerca;


			var newDD = loadedData.filter(function (station) {
				return station.title.toLowerCase().indexOf(filtreCerca.toLowerCase()) != -1;
			});

			return newDD.map(function (station, i) {
				return _this3.renderLListatApps(station, i);
			});
		}
	}, {
		key: "renderApplicationsListOLd",
		value: function renderApplicationsListOLd() {

			if (this.state.loading) {
				return _react2.default.createElement(
					_semanticUiReact.Loader,
					{ size: "huge", active: true },
					"Carregant dades..."
				);
			} else if (this.state.showError) {

				return _react2.default.createElement(
					_semanticUiReact.Message,
					{ negative: true },
					_react2.default.createElement(
						_semanticUiReact.Message.Header,
						null,
						"Error"
					),
					_react2.default.createElement(
						"p",
						null,
						"Ha ocorregut un error: ",
						this.state.errorMsg
					)
				);
			}

			return _react2.default.createElement(
				_semanticUiReact.Card.Group,
				null,
				this.renderApplications()
			);
		}
	}, {
		key: "renderApplicationsList",
		value: function renderApplicationsList() {
			var _this4 = this;

			var style = { width: "99%" };
			var columnStateStyle = { width: "300px" };
			var columnStateStyle2 = { width: "200px" };
			var color = "teal";

			if (this.state.loading) {
				return _react2.default.createElement(
					_semanticUiReact.Loader,
					{ size: "huge", active: true },
					"Carregant dades..."
				);
			} else if (this.state.showError) {

				return _react2.default.createElement(
					_semanticUiReact.Message,
					{ negative: true },
					_react2.default.createElement(
						_semanticUiReact.Message.Header,
						null,
						"Error"
					),
					_react2.default.createElement(
						"p",
						null,
						"Ha ocorregut un error: ",
						this.state.errorMsg
					)
				);
			}
			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(_semanticUiReact.Input, { size: "large", icon: "search", onChange: function onChange(e, data) {
						return _this4.onSelectVisors(data.value);
					}, placeholder: "Cercar..." }),
				_react2.default.createElement("hr", null),
				_react2.default.createElement(
					"div",
					{ className: _Llistat2.default.myTable },
					_react2.default.createElement(
						_semanticUiReact.Table,
						{ style: style, color: color, key: color, columns: 1, fixed: true, sortable: true, selectable: true, verticalAlign: "middle" },
						_react2.default.createElement(
							_semanticUiReact.Table.Header,
							{ className: _Llistat2.default.myTableHeader, color: color, key: color },
							_react2.default.createElement(
								_semanticUiReact.Table.Row,
								null,
								_react2.default.createElement(
									_semanticUiReact.Table.HeaderCell,
									{ style: columnStateStyle },
									"Visors"
								)
							)
						),
						_react2.default.createElement(
							_semanticUiReact.Table.Body,
							null,
							this.renderApplications()
						)
					)
				)
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _state2 = this.state,
			    open = _state2.open,
			    titleMsg = _state2.titleMsg,
			    bodyMsg = _state2.bodyMsg;


			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(_FixedMenuLayout2.default, { title: "Llista de mapes.", isVisor: true }),
				_react2.default.createElement(
					_semanticUiReact.Container,
					{ fluid: true, className: _Llistat2.default.containerStyle, textAlign: "justified" },
					this.renderApplicationsList()
				)
			);
		}
	}]);

	return Llistat;
}(_react2.default.Component);

exports.default = Llistat;


Llistat.propTypes = {
	params: _propTypes2.default.object,
	header: _propTypes2.default.string
};
